import { autoinject } from 'aurelia-framework';
import { ApiService } from '../../utils/api-service';

export class ScopeTypeGroup {
    id: string;
    name: string;
}

@autoinject
export class ScopeTypeGroupService {
    scopeTypeGroups: ScopeTypeGroup[];
    selectedScopeTypeGroup: ScopeTypeGroup;

    constructor(private api: ApiService) {}

	private groups:Promise<ScopeTypeGroup[]> = null;
	getScopeTypeGroups(): Promise<ScopeTypeGroup[]> {
		if (this.groups == null) {
			this.groups = this.api.fetchJson('scope-type-groups').then(groups => {
				return groups;
			});
		}

		return this.groups;
	}
}
